var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57901 4.09326H8.65233C8.74213 4.09328 8.82991 4.11992 8.90457 4.16982C8.97923 4.21972 9.03742 4.29064 9.07178 4.3736C9.10615 4.45657 9.11514 4.54786 9.09763 4.63594C9.08011 4.72401 9.03688 4.80492 8.97339 4.86843L6.43673 7.40508C6.35157 7.49021 6.23609 7.53804 6.11567 7.53804C5.99526 7.53804 5.87978 7.49021 5.79462 7.40508L3.25796 4.86843C3.19447 4.80492 3.15123 4.72401 3.13372 4.63594C3.11621 4.54786 3.1252 4.45657 3.15956 4.3736C3.19392 4.29064 3.25211 4.21972 3.32677 4.16982C3.40143 4.11992 3.48921 4.09328 3.57901 4.09326Z",
    fill: "#92929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownLight);
export default __webpack_public_path__ + "static/media/caret_down_light.bb87c494cbcc5e69a43b08aca4d8fa62.svg";
export { ForwardRef as ReactComponent };